import React from "react";

export interface IAccordionContext {
    activeElement: React.RefObject<HTMLDivElement> | null;
    setActiveElement: (element: React.RefObject<HTMLDivElement> | null) => void;
}

export const AccordionContext = React.createContext<IAccordionContext>({
    activeElement: null,
    setActiveElement: () => {
        throw new Error("Context not provided");
    }
});

const AccordionProvider = ({ children }) => {
    const [activeElement, setActiveElement] = React.useState<React.RefObject<HTMLDivElement> | null>(null);
    const value = React.useMemo(() => ({ activeElement, setActiveElement }), [activeElement]);

    return <AccordionContext.Provider value={value}>{children}</AccordionContext.Provider>;
};

export default AccordionProvider;
